import React from "react";
import Reveal from "./Reveal";

function SectionHeading({ kicker, title, subtitle, align = "left" }) {
  const alignment =
    align === "center" ? "items-center text-center" : "items-start text-left";
  return (
    <Reveal className={`flex w-full min-w-0 flex-col gap-3 ${alignment}`}>
      {kicker && (
        <span className="chip max-w-full font-mono text-[0.7rem] uppercase tracking-[0.2em] text-accent-soft">
          <span className="h-1.5 w-1.5 shrink-0 rounded-full bg-accent" />
          {kicker}
        </span>
      )}
      <h2 className="w-full text-[1.7rem] font-bold text-ink sm:text-4xl md:text-[2.75rem]">
        {title}
      </h2>
      {subtitle && (
        <p className="w-full max-w-2xl text-base text-ink-muted sm:text-lg">
          {subtitle}
        </p>
      )}
    </Reveal>
  );
}

export default SectionHeading;
